import * as React from "react";

const Spinner = () => {
  return (
    <div
      style={{
        marginTop: 16,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        className="spinner-border text-light"
        role="status"
        style={{ width: "30px", height: "30px" }}
      >
        <span className="sr-only"></span>
      </div>
    </div>
  );
};

export default Spinner;
